/**
 * "Needs you" items older than this leave the headline count. They are still
 * shown — folded, with a Dismiss all — so the number on the sidebar means
 * "act today", not "everything that ever went unanswered".
 */
export const STALE_AFTER_DAYS = 30;

const STALE_AFTER_MS = STALE_AFTER_DAYS * 86_400_000;

export function isStale(waitingSince: string, now = Date.now()): boolean {
  return now - new Date(waitingSince).getTime() > STALE_AFTER_MS;
}

/** Split a needs-you list into what counts and what has gone stale. */
export function staleNeedsYou<T extends { waitingSince: string }>(
  items: T[],
  now = Date.now(),
): { fresh: T[]; stale: T[] } {
  const fresh: T[] = [];
  const stale: T[] = [];
  for (const item of items) (isStale(item.waitingSince, now) ? stale : fresh).push(item);
  return { fresh, stale };
}
